import clsx from 'clsx';
import * as React from 'react';

interface Props {
  label: React.ReactNode;
  icon: React.ReactNode;
  badgeCount: number;
  active: boolean;
  controls: string;
  onClick: () => void;
  intercomTarget: string;
  dataTest: Record<string, boolean>;
}

function ToolButton({
  label,
  icon,
  badgeCount,
  active,
  controls,
  onClick,
  intercomTarget,
  dataTest,
}: Props) {
  return (
    <button
      type="button"
      className={clsx(
        'flex h-14 min-w-[4.5rem] cursor-pointer flex-col items-center justify-center gap-1 rounded-lg border-0 px-2',
        'text-gray-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary',
        active ? 'bg-white text-teal-800 shadow' : 'bg-transparent hover:bg-white/70',
      )}
      aria-expanded={active}
      aria-controls={controls}
      onClick={onClick}
      data-intercom-target={intercomTarget}
      {...dataTest}
    >
      <span className="relative inline-flex h-6 w-6 items-center justify-center">
        {icon}
        {badgeCount > 0 && (
          <span
            className="absolute -right-3 -top-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-red-700 px-1 text-[11px] font-bold leading-none text-white"
            data-test-tab-badge={badgeCount}
          >
            {badgeCount}
          </span>
        )}
      </span>
      <span className="text-xs leading-none">{label}</span>
    </button>
  );
}

export default ToolButton;
